import { ConvertHistoryListPage } from "@/features/convert/pages/ConvertHistoryList";

function ConvertHistoryList() {
  return <ConvertHistoryListPage />;
}

export default ConvertHistoryList;
